@if (device && !groupDevice && params && params.context) {
	<div
		class="sh-device-status-cell"
		[class.sh-offline-device]="device.status === deviceStatus.Offline"
		*transloco="let t; read: 'online-devices'"
	>
		@if (device.status === deviceStatus.Discovered && deviceError !== deviceErrorType.DiscoveryError) {
			<prism-tooltip [text]="'common.device-status.device-discovered-loading' | transloco" placement="top">
				<prism-progress-indicator type="circular" mode="indeterminate"></prism-progress-indicator>
			</prism-tooltip>
		} @else {
			@switch (deviceError) {
				@case (deviceErrorType.NewDevice) {
					<prism-tooltip [text]="deviceErrorTooltip" placement="top">
						<button
							class="sh-new-button"
							(click)="onNewDeviceButtonClick($event, device)"
							[disabled]="device.status === deviceStatus.Offline"
						>
							{{ t('new-device-setup.new') }}
						</button>
					</prism-tooltip>
				}
				@case (deviceErrorType.Offline) {
					<ng-container
						*ngTemplateOutlet="
							errorIconTemplate;
							context: {
								class: 'sh-offline-device-error-icon'
							}
						"
					></ng-container>
				}
				@case (deviceErrorType.IncompatibleFirmware) {
					<ng-container
						*ngTemplateOutlet="
							errorIconTemplate;
							context: {
								class: 'sh-incompatible-firmware-device-error-icon'
							}
						"
					></ng-container>
				}
				@case (deviceErrorType.InvalidFirmware) {
					<ng-container
						*ngTemplateOutlet="
							errorIconTemplate;
							context: {
								class: 'sh-invalid-firmware-device-error-icon'
							}
						"
					></ng-container>
				}
				@case (deviceErrorType.DiscoveryError) {
					<ng-container
						*ngTemplateOutlet="
							errorIconTemplate;
							context: {
								class: 'sh-device-discovery-error-icon',
								onClick: onErrorIconClick
							}
						"
					></ng-container>
				}
				@case (deviceErrorType.PoELoudspeaker) {
					<ng-container
						*ngTemplateOutlet="
							errorIconTemplate;
							context: {
								class: 'sh-device-power-loudspeaker-error-icon',
								onClick: onPoeIconClick
							}
						"
					></ng-container>
				}
				@case (deviceErrorType.PoEGeneric) {
					<ng-container
						*ngTemplateOutlet="
							warningIconTemplate;
							context: {
								class: 'sh-device-power-generic-error-icon',
								onClick: onPoeIconClick
							}
						"
					></ng-container>
				}
				@case (deviceErrorType.LoudspeakerOff) {
					<ng-container
						*ngTemplateOutlet="
							warningIconTemplate;
							context: {
								class: 'sh-device-loudspeaker-off-icon'
							}
						"
					></ng-container>
				}
				@case (deviceErrorType.OutOfRangeError) {
					<ng-container
						*ngTemplateOutlet="
							errorIconTemplate;
							context: {
								class: 'sh-device-out-of-range-icon'
							}
						"
					></ng-container>
				}
				@case (deviceErrorType.RFScanInProgress) {
					<ng-container
						*ngTemplateOutlet="
							radarIconTemplate;
							context: {
								class: 'sh-device-rf-scan-in-progress-icon'
							}
						"
					></ng-container>
				}
				@case (deviceErrorType.WeakRFStrengthError) {
					<ng-container
						*ngTemplateOutlet="
							errorIconTemplate;
							context: {
								class: 'sh-device-weak-rf-strength-icon'
							}
						"
					></ng-container>
				}
				@case (deviceErrorType.LowBatteryError) {
					<ng-container
						*ngTemplateOutlet="
							errorIconTemplate;
							context: {
								class: 'sh-device-low-battery-error-icon'
							}
						"
					></ng-container>
				}
				@case (deviceErrorType.LowBatteryWarning) {
					<ng-container
						*ngTemplateOutlet="
							warningIconTemplate;
							context: {
								class: 'sh-device-low-batterry-warning-icon'
							}
						"
					></ng-container>
				}
				@case (deviceErrorType.ChargingError) {
					<ng-container
						*ngTemplateOutlet="
							errorIconTemplate;
							context: {
								class: 'sh-device-charging-error-icon'
							}
						"
					></ng-container>
				}
				@case (deviceErrorType.IncompatibleAPXWithMXWWarning) {
					@if (selectedView === onlineDevicesView.Connections || isTransmitterDevice) {
						<ng-container
							*ngTemplateOutlet="
								warningIconTemplate;
								context: {
									class: 'sh-device-incompatible-apx-with-mxw-icon'
								}
							"
						></ng-container>
					}
				}
				@case (deviceErrorType.IncompatibleNDXWithMXWWarning) {
					@if (selectedView === onlineDevicesView.Connections || isTransmitterDevice) {
						<ng-container
							*ngTemplateOutlet="
								warningIconTemplate;
								context: {
									class: 'sh-device-incompatible-ndx-with-mxw-icon'
								}
							"
						></ng-container>
					}
				}
				@case (deviceErrorType.DanteLocked) {
					<ng-container
						*ngTemplateOutlet="
							warningIconTemplate;
							context: {
								class: 'sh-warning-icon',
								onClick: onDanteLockedIconClick
							}
						"
					></ng-container>
				}
				@case (deviceErrorType.EncryptionError) {
					<ng-container
						*ngTemplateOutlet="
							iconTemplate;
							context: {
								class: 'sh-device-encryption-error-icon',
								svgIcon: 'vpn_key',
								iconColor: 'var(--prism-color-theme-state-bad)',
								tooltip: t('encryption-error')
							}
						"
					></ng-container>
				}
				@case (deviceErrorType.LinkedTransmitterError) {
					@if (selectedView === onlineDevicesView.Connections) {
						<ng-container
							*ngTemplateOutlet="
								errorIconTemplate;
								context: {
									class: 'sh-linked-transmitter-device-error-icon'
								}
							"
						></ng-container>
					}
				}
				@case (deviceErrorType.LinkedTransmitterWarning) {
					@if (selectedView === onlineDevicesView.Connections) {
						<ng-container
							*ngTemplateOutlet="
								warningIconTemplate;
								context: {
									class: 'sh-linked-transmitter-device-warning-icon'
								}
							"
						></ng-container>
					}
				}
				@case (deviceErrorType.DockedTransmitterError) {
					@if (selectedView === onlineDevicesView.Connections) {
						<ng-container
							*ngTemplateOutlet="
								errorIconTemplate;
								context: {
									class: 'sh-docked-transmitter-device-error-icon'
								}
							"
						></ng-container>
					}
				}
				@case (deviceErrorType.DockedTransmitterWarning) {
					@if (selectedView === onlineDevicesView.Connections) {
						<ng-container
							*ngTemplateOutlet="
								warningIconTemplate;
								context: {
									class: 'sh-docked-transmitter-device-warning-icon'
								}
							"
						></ng-container>
					}
				}
				@case (
					deviceError === deviceErrorType.LicenseError || deviceError === deviceErrorType.LicenseWarning
						? deviceError
						: ''
				) {
					@if (device.features.license; as license) {
						@if (license.state !== deviceLicenseState.ActivationConfirmed) {
							<sh-device-license-state-icon
								[warningTemplateRef]="warningIconTemplate"
								[errorTemplateRef]="errorIconTemplate"
								[deviceLicense]="license"
							></sh-device-license-state-icon>
						}
					}
				}
			}
		}
	</div>
}

@if (groupDevice) {
	<div>
		<span>{{ groupDevice.statusCellData.filterText }}</span>
	</div>
}

@if (groupedByOtherColumn) {
	<span>--</span>
}

<ng-template #warningIconTemplate let-class="class" let-tooltip="tooltip" let-onClick="onClick">
	<ng-container
		*ngTemplateOutlet="
			iconTemplate;
			context: {
				icon: 'sh-warning-outline',
				iconColor: 'var(--prism-color-theme-state-ok)',
				class,
				tooltip,
				onClick
			}
		"
	></ng-container>
</ng-template>

<ng-template #errorIconTemplate let-class="class" let-tooltip="tooltip" let-onClick="onClick">
	<ng-container
		*ngTemplateOutlet="
			iconTemplate;
			context: {
				icon: 'sh-error-outline',
				iconColor: 'var(--prism-color-theme-state-bad)',
				class,
				tooltip,
				onClick
			}
		"
	></ng-container>
</ng-template>

<ng-template #radarIconTemplate let-class="class" let-tooltip="tooltip" let-onClick="onClick">
	<ng-container
		*ngTemplateOutlet="
			iconTemplate;
			context: { svgIcon: 'radar', iconColor: 'var(--prism-color-theme-brand-orange)', class, tooltip, onClick }
		"
	></ng-container>
</ng-template>

<ng-template
	#iconTemplate
	let-icon="icon"
	let-svgIcon="svgIcon"
	let-iconColor="iconColor"
	let-class="class"
	let-onClick="onClick"
>
	@if (onClick) {
		<prism-icon-button
			[ngClass]="['sh-icon', class ?? '', onClick ? 'sh-clickable-icon' : '']"
			[icon]="svgIcon ?? icon"
			[ngStyle]="{ '--prism-icon-button-color': iconColor }"
			tooltipPlacement="top"
			[label]="deviceErrorTooltip"
			(click)="onClick && onClick($event)"
		></prism-icon-button>
	} @else {
		<prism-tooltip [text]="deviceErrorTooltip" placement="top">
			<prism-icon
				[ngClass]="['sh-icon', class ?? '']"
				[icon]="svgIcon ?? icon"
				[ngStyle]="{ color: iconColor }"
			></prism-icon>
		</prism-tooltip>
	}
</ng-template>
